import { Injectable } from '@angular/core';

import { LazyServiceProviderBase } from './lazy-service-provider-base';

/**
 * @stable
 */
export interface LoyaltyLoginValidation {
    loyaltyAccountName: string;
    loyaltyCardNo: string;
}

/**
 * @stable
 */
@Injectable({
    providedIn: 'root',
})
export class LoyaltyLoginCoreService extends LazyServiceProviderBase {
    /**
     * The current loyalty login validation object.
     */
    get loyaltyValidation(): LoyaltyLoginValidation | undefined {
        return this.isReady ? this.inner.loyaltyValidation : undefined;
    }
}
